import { type PopupProps, Popup } from '@CS/components/Popups';
import { useNavigateQuery } from '@/hooks';
import { useTranslation } from '@CS/hooks';
import Button from '@CS/components/Button';
import CSS from './Submit.module.css';
import Content from './content';

export const Submit = (props: PopupProps) => {
  const navigate = useNavigateQuery();
  const onClick = () => navigate('/');
  const { title, back } = useTranslation(Content);

  return (
    <Popup
      hideClose
      {...props}
      opacity="0"
      className={CSS.submitContainer}
    >
      <div className={CSS.submitContent}>
        <h4>{title}</h4>
        <Button text={back} onClick={onClick} />
      </div>
    </Popup>
  );
};
